import { makeStyles } from '@material-ui/core';

import PropTypes from 'prop-types';

import { Section, SectionAlternate } from '@/src/components/organisms';

import {
  Faq,
  Find,
  FooterNewsletter,
  Hero,
  News,
  Referral,
  Reviews,
  Personas,
  TrackOrder,
} from './components';

const useStyles = makeStyles(theme => ({
  sectionAlternate: {
    background: 'transparent',
    backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 400px, ${theme.palette.primary.light} 0%)`,
  },
  footerNewsletterSection: {},
  trackOrderSection: {
    backgroundColor: theme.palette.background.level2,
    borderRadius: '0 60% 0 0',
  },
}));

function IndexView({ doc }) {
  const classes = useStyles();

  const { articles = {} } = doc;

  return (
    <div>
      <Hero cta={<Personas />} />
      <Section>
        <Find />
      </Section>
      <SectionAlternate className={classes.trackOrderSection}>
        <TrackOrder />
      </SectionAlternate>
      <SectionAlternate className={classes.sectionAlternate}>
        <Referral />
      </SectionAlternate>
      <Section>
        <Reviews />
      </Section>
      <SectionAlternate>
        <News data={articles?.results} />
      </SectionAlternate>
      <Section>
        <Faq />
      </Section>
      <SectionAlternate className={classes.footerNewsletterSection}>
        <FooterNewsletter />
      </SectionAlternate>
    </div>
  );
}

IndexView.propTypes = {
  doc: PropTypes.object,
};

export default IndexView;
